import AgentImg from "../assets/avatars/2.png";
import DrAnikaImg from "../assets/dranika.png";
import PoweredBySvg from "../assets/poweredBy.svg"
import { Button } from 'primereact/button';

export default function AgentSidebar({ 
  agentData, 
  useHeyGen = false, 
  audioUnlocked, 
  unlockAudio, 
  heygenReady = false, 
  heygenVideoRef, 
  heygenAudioRef, 
  heygenLoading = false, 
  heygenError = null, 
  heygenNeedsInteraction = false, 
  heygenEnableAudio,
  heygenStarted = false,
  onStartAvatar,
  onStopAvatar
}) {
  console.log({
    muted: heygenVideoRef.current?.muted,
    paused: heygenVideoRef.current?.paused,
    readyState: heygenVideoRef.current?.readyState,
  });
  return (
    <div className="w-full md:w-96 bg-white/80 backdrop-blur-xl shadow-2xl md:border-r border-gray-200/50">
      <div className="p-6 bg-gradient-to-br from-white to-gray-50/50 md:h-screen flex flex-col md:justify-center">
        <h3 className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-6 text-center">You're talking to</h3>
        <div className="flex flex-col items-center text-center">
          <div className="relative group mb-2">
            {useHeyGen ? (
              <>
                {/* Show Dr. Anika image as fallback when HeyGen is loading or not ready */}
                <img
                  src={DrAnikaImg}
                  alt="Dr. Anika"
                  className={`w-52 h-52 rounded-3xl object-cover shadow-2xl ring-4 ring-white absolute transition-opacity duration-300
                  ${heygenReady && !heygenLoading ? "opacity-0 invisible" : "opacity-100 visible"}`}
                />
                <video
                  ref={heygenVideoRef}
                  autoPlay
                  playsInline
                  className={`w-52 h-52 rounded-3xl object-cover shadow-2xl ring-4 ring-white relative
                  ${!heygenReady || heygenLoading ? "opacity-0 invisible pointer-events-none" : "opacity-100 visible"}`}
                />
                {/* <audio
                  ref={heygenAudioRef}
                  autoPlay
                  playsInline
                /> */}
                {/* {!audioUnlocked && (
                  <button onClick={unlockAudio} className="absolute inset-0 flex items-center justify-center bg-black/50 rounded-3xl text-white text-sm">
                    Tap to enable avatar sound
                  </button>
                )} */}
              </>
            ) : (
              <img
                src={DrAnikaImg}
                alt="Dr. Anika"
                className="w-40 h-40 md:w-48 md:h-48 rounded-3xl object-cover shadow-2xl group-hover:shadow-3xl transition-all duration-300 transform group-hover:scale-105 ring-4 ring-white"
              />
            )}
            <div className="absolute -top-2 -right-2 w-9 h-9 bg-gradient-to-br from-blue-400 to-blue-600 rounded-full flex items-center justify-center shadow-lg ring-4 ring-white">
              <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 20 20">
                <path
                  fillRule="evenodd"
                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                  clipRule="evenodd"
                />
              </svg>
            </div>
          </div>
          
          {/* Start/Stop Avatar Buttons - Below Avatar Image */}
          {useHeyGen && (
            <div className="flex flex-col gap-2 mb-4 items-center mt-2">
              {!heygenStarted ? (
                // <Button
                //   label="Start Avatar"
                //   icon="pi pi-play"
                //   onClick={onStartAvatar}
                //   loading={heygenLoading}
                //   style={{ 
                //     width: '12rem',
                //     padding: '0.5rem 1rem',
                //     fontSize: '0.8rem',
                //     fontWeight: '600',
                //     borderRadius: '0.5rem',
                //     background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                //     border: 'none',
                //     color: 'white',
                //     boxShadow: '0 4px 15px rgba(102, 126, 234, 0.4)',
                //     transition: 'all 0.3s ease'
                //   }}
                //   onMouseEnter={(e) => {
                //     e.target.style.transform = 'translateY(-2px)';
                //     e.target.style.boxShadow = '0 6px 20px rgba(102, 126, 234, 0.6)';
                //   }}
                //   onMouseLeave={(e) => {
                //     e.target.style.transform = 'translateY(0)';
                //     e.target.style.boxShadow = '0 4px 15px rgba(102, 126, 234, 0.4)';
                //   }}
                // />
                ""
              ) : (
                <Button
                  label="Stop Avatar"
                  icon="pi pi-stop"
                  onClick={onStopAvatar}
                  disabled={heygenLoading}
                  style={{ 
                    width: '12rem',
                    padding: '0.5rem 1rem',
                    fontSize: '0.8rem',
                    fontWeight: '600',
                    borderRadius: '0.5rem',
                    background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
                    border: 'none',
                    color: 'white',
                    boxShadow: '0 4px 15px rgba(245, 87, 108, 0.4)',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseEnter={(e) => {
                    if (!heygenLoading) {
                      e.target.style.transform = 'translateY(-2px)';
                      e.target.style.boxShadow = '0 6px 20px rgba(245, 87, 108, 0.6)';
                    }
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = '0 4px 15px rgba(245, 87, 108, 0.4)';
                  }}
                />
              )}
              {heygenLoading && (
                <p className="text-xs text-center text-gray-600 mt-1">Connecting...</p>
              )}
              {heygenError && (
                <p className="text-xs text-center text-red-600 mt-1">{heygenError}</p>
              )}
            </div>
          )}
          
          <div className="w-full px-4">
            <h4 className="font-bold text-gray-900 text-xl md:text-2xl mb-2">
              {agentData?.name || 'Agent'}
            </h4>
            <p className="text-xs md:text-sm font-semibold text-blue-600 mb-2">Obesity Specialist Agent</p>
            <p className="text-gray-800 text-sm md:text-[15px] leading-6 font-normal mt-2 max-w-sm text-left">Advanced obesity specialist AI with deep expertise in anti-obesity medications, metabolic surgery, and lifestyle interventions. Delivers evidence-based insights from pivotal trials with precise medical terminology for healthcare professionals.</p>
            {agentData?.description && (
              <p className="text-xs text-gray-600 leading-relaxed mb-4 px-2">
                {agentData.description}
              </p>
            )}
            {/* <div className="bg-gradient-to-r from-blue-50 to-purple-50 rounded-xl p-4 space-y-2.5 mt-4">
              <div className="flex items-center justify-center gap-2 text-xs text-gray-600">
                <svg className="w-4 h-4 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
                <span>{useHeyGen && heygenStarted ? (heygenReady ? 'Active' : 'Connecting...') : 'Available for consultation'}</span>
              </div>
              <div className="flex items-center justify-center gap-2 text-xs text-gray-600">
                <svg className="w-4 h-4 text-blue-500" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M2 5a2 2 0 012-2h7a2 2 0 012 2v4a2 2 0 01-2 2H9l-3 3v-3H4a2 2 0 01-2-2V5z" />
                  <path d="M15 7v2a4 4 0 01-4 4H9.828l-1.766 1.767c.28.149.599.233.938.233h2l3 3v-3h2a2 2 0 002-2V9a2 2 0 00-2-2h-1z" />
                </svg>
                <span>Available for consultation</span>
              </div>
            </div> */}
          </div>
        </div>
        <div className="p-5">
          <a href="https://curebay.com/" target="_blank" rel="noopener noreferrer">
            <img style={{
              width: "107px",
              height: "34px",
            }} className='mt-2' src={PoweredBySvg} alt='Powered By Curebay' />
          </a>
        </div>
      </div>
    </div>
  );
}